export const data = [
  {
    id: 1,
    phase: "Phase 1",
    title: " Platform Launch",
    primary: {
      heading: "Pre-Token Offering (PTO)",
      description: " October to December 2024",
      headingTwo: "Launch of NFT minting and marketplace :",
      descriptionTwo:
        "late December 2024, Tours and field trips - Celebrity mining partnerships with tours and mining experts – May 2025",
    },
  },
  {
    id: 2,
    phase: "Phase 2",
    title: "Ecosystem Expansion",
    primary: {
      heading: "Cross-chain NFT functionality-",
      description: "TBA.",
      headingTwo: "Introduction of staking and rewards :",
      descriptionTwo: "TBA",
    },
  },
  {
    id: 3,
    phase: "Phase 3",
    title: "Community Engagement",
    primary: {
      heading: "",
      description:
        "Invitations to selected token holders to attend hosted events E.g. Token 2049 or participate at a higher level in the project, subject to the token holder having the required skill sets.",
    },
  },
  {
    id: 4,
    phase: "Phase 4",
    title: "Partnerships and Global Expansion",
    primary: {
      heading: "",
      description: "Collaboration with eco-friendly organisations.",
      headingTwo: "",
      descriptionTwo:
        "Partnerships with community groups and educational institutions..",
    },
  },
];
